<script setup lang="ts">
import { HomeButton } from '@/components/home'
import { usePathwayCompletionChallenge } from '@/composables/game/challenges'
import DoubleArrowsUpImage from '@/assets/images/pathway-double-arrows-up.png'
import { twMerge } from 'tailwind-merge'

withDefaults(defineProps<{
  containerClass?: string
}>(), {
  containerClass: '',
})

const { countdown, isPathwayCompletionChallengeLive } = usePathwayCompletionChallenge()
</script>

<template>
  <HomeButton
    v-if="isPathwayCompletionChallengeLive"
    label="Challenge"
    :countdown="{ value: countdown, dangerThreshold: 3600 * 3 }"
    :show-sparkle="true"
    :button-class="twMerge('bg-[linear-gradient(180deg,#EED652_0.01%,#4F59AF_23.08%,#000_36.54_]() p-0.5', containerClass)"
  >
    <img
      class="size-10 object-cover z-[3]"
      :src="DoubleArrowsUpImage"
    >
  </HomeButton>
</template>
